@custom-media --mobile (max-width: 768px);

.container {
  margin-top: 2em;
}

.row {
  & td {
    padding: 2em 1.5em;
    min-width: 5em;
  }
}

.listing {
  font-weight: bold;
  font-size: 0.8em;
  margin-bottom: 4em;

  @media (--mobile) {
    margin-bottom: 2em;
  }
}

.row:nth-child(odd) {
  background-color: var(--silver);
}

.row:nth-child(even) {
  background-color: var(--white);
}

.header {
  & th {
    padding-left: 1.5em;
    padding-top: 1em;
    min-width: 4em;
    padding-bottom: 0.5em;
  }
}

.centeredText {
  text-align: center;
}

.borders {
  border: 1px solid var(--mediumSilver);
  border-top-width: 0;
  border-bottom-width: 0;
}

.borders:first-child {
  border-top: 1px solid var(--mediumSilver);
}

.borders:last-child {
  border-bottom: 1px solid var(--mediumSilver);
}

.status {
  text-align: right;

  p {
    margin-bottom: 0;
    font-size: 1em;
  }
}

.statusHeader {
  text-align: right;
  padding-right: 1em;
}

.statusIcon {
  padding-left: 0.5em;
}
